<template>
    <!--
          作者：kmdshop
          时间：2019-10-25
          描述：组件-选择门店
      -->
    <el-dialog title="选择门店" :visible.sync="dialogVisible" @close="cancelFunc" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false" width="880px">
      <div class="common-seach-wrap">
        <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="门店名称"><el-input placeholder="请输入门店名称"  
                style="width: 118px;" v-model="formInline.name"></el-input></el-form-item>
        
           <el-form-item label="联系人/联系方式"><el-input placeholder="请输入联系人/联系方式"  
            style="width: 118px;" v-model="formInline.mobile"></el-input></el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" @click="search">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
  
      <!--内容-->
      <div class="product-content">
        <div class="table-wrap">
          <el-table :data="tableData" size="small" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
     
            <el-table-column prop="store_name" label="门店名称"></el-table-column>
            <el-table-column prop="linkman" label="联系人"></el-table-column>
            <el-table-column prop="phone" label="联系方式"></el-table-column>
        
            <el-table-column type="selection" width="45" v-if="multi"></el-table-column>
            <el-table-column label="操作" width="80" v-else>
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="selectUser(scope.row)">选择</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
  
        <!--分页-->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-sizes="[2, 10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
          ></el-pagination>
        </div>
      </div>
  
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmFunc">确 定</el-button>
      </div>
    </el-dialog>
  </template>
  
  <script>
  import DataApi from '@/api/data.js';
  export default {
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*当前是第几页*/
        curPage: 1,
        /*一页多少条*/
        pageSize: 15,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*搜索表单对象*/
        formInline: {
            name:"",
            mobile:""
        },
        /*会员列表*/
        tableData: [],
        /*选中的*/
        multipleSelection: [],
        /*是否显示*/
        dialogVisible: false,
        sure_close:false,
      };
    },
    props: {
      // 开启弹窗
      is_open: Boolean,
      // 是否多选
      multi: {
        type: Boolean,
        default: () => {
          return true
        }
      },
    },
    watch: {
      is_open: function(n, o) {
        console.log("n",n);
        if (n != o) {
          
          this.dialogVisible = n;
          if (n) {
            this.getTableList();
          }
        }
      }
    },
    created() {},
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },
  
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
  
      /*获取数据*/
      getTableList() {
        let self = this;
        self.loading = true;
        let params = self.formInline;
        params.page = self.curPage;
        params.list_rows = self.pageSize;
        DataApi.getStore(params,true).then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
            self.gradeList = data.data.grade;
          })
          .catch(error => {
            self.loading = false;
          });
      },
  
      /*查询*/
      search() {
        this.curPage = 1;
        this.tableData = [];
        this.getTableList();
      },
  
      /*点击确定*/
      confirmFunc() {
        let params = this.multipleSelection;
        this.sure_close = true;
        this.emitFunc( params);
      },
  
      /*关闭弹窗*/
      cancelFunc(e) {

        if(!this.sure_close){
          this.emitFunc();
        }
       
      },
  
      /*发送事件*/
      emitFunc(e) {
        this.dialogVisible = false;
        if (e && typeof e != 'undefined') {
          this.$emit('closex', {
            type: 'success',
            params: e
          });
        } else {
          this.$emit('closex', {
            type: 'error'
          });
        }
      },
  
      /*监听单选按钮选中事件*/
      selectUser(val) {
        this.multipleSelection = val;
        this.confirmFunc();
      },
  
      /*选择门店*/
      handleSelectionChange(e) {
        this.multipleSelection = e;
      }
    }
  };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/components/store/Store.vue